(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7427],{

/***/ 67252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/logout",
      function () {
        return __webpack_require__(95021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingScreen; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32970);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40549);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36822);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74608);





// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        right: 0,
        bottom: 0,
        zIndex: 99999,
        width: "100%",
        height: "100%",
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.background.default
    };
});
function LoadingScreen(props) {
    var companyColor = props.companyColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RootStyle, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div, {
                initial: {
                    rotateY: 0
                },
                animate: {
                    rotateY: 360
                },
                transition: {
                    duration: 2,
                    ease: "easeInOut",
                    repeatDelay: 1,
                    repeat: Infinity
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    disabledLink: true,
                    sx: {
                        width: 64,
                        height: 64
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                component: framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div,
                animate: {
                    scale: [
                        1.2,
                        1,
                        1,
                        1.2,
                        1.2
                    ],
                    rotate: [
                        270,
                        0,
                        0,
                        270,
                        270
                    ],
                    opacity: [
                        0.25,
                        1,
                        1,
                        1,
                        0.25
                    ],
                    borderRadius: [
                        "25%",
                        "25%",
                        "50%",
                        "50%",
                        "25%"
                    ]
                },
                transition: {
                    ease: "linear",
                    duration: 3.2,
                    repeat: Infinity
                },
                sx: {
                    width: 100,
                    height: 100,
                    borderRadius: "25%",
                    position: "absolute",
                    border: function(theme) {
                        return "solid 3px ".concat((0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(companyColor !== null && companyColor !== void 0 ? companyColor : theme.palette.primary.dark, 0.24));
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                component: framer_motion__WEBPACK_IMPORTED_MODULE_3__.m.div,
                animate: {
                    scale: [
                        1,
                        1.2,
                        1.2,
                        1,
                        1
                    ],
                    rotate: [
                        0,
                        270,
                        270,
                        0,
                        0
                    ],
                    opacity: [
                        1,
                        0.25,
                        0.25,
                        0.25,
                        1
                    ],
                    borderRadius: [
                        "25%",
                        "25%",
                        "50%",
                        "50%",
                        "25%"
                    ]
                },
                transition: {
                    ease: "linear",
                    duration: 3.2,
                    repeat: Infinity
                },
                sx: {
                    width: 120,
                    height: 120,
                    borderRadius: "25%",
                    position: "absolute",
                    border: function(theme) {
                        return "solid 8px ".concat(companyColor !== null && companyColor !== void 0 ? companyColor : (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.primary.dark, 0.24));
                    }
                }
            })
        ]
    });
}


/***/ }),

/***/ 74608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36822);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29430);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28821);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83330);
/* harmony import */ var _theme_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9671);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  object-fit: contain;\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ",
        "px;\n  @media (max-width: 768px) {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var Img = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-7c8e6a29-0"
})(_templateObject());
var ImgContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7c8e6a29-1"
})(_templateObject1(), _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].appBar.desktop */ .Z.appBar.desktop - _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].elementGap.desktop */ .Z.elementGap.desktop, _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].appBar.mobile */ .Z.appBar.mobile - _theme_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"].elementGap.mobile */ .Z.elementGap.mobile);
var Logo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var isHome = param.isHome, isMint = param.isMint, isOffset = param.isOffset, _disabledLink = param.disabledLink, disabledLink = _disabledLink === void 0 ? false : _disabledLink, sx = param.sx;
    var _$ref = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), appId = _$ref.id, appLogo = _$ref.logo;
    var getLogoSrc = function(appId) {
        switch(appId){
            // custom logo because of white and black
            case _appConfig__WEBPACK_IMPORTED_MODULE_5__/* .AppIdEnum.agafgoon */ ._S.agafgoon:
                return isHome && !isOffset || isMint ? "/logo/agaf-white.png" : appLogo;
            default:
                return appLogo;
        }
    };
    var _$ref1;
    var logo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgContainer, {
        ref: ref,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            cursor: "pointer"
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
            src: (_$ref1 = getLogoSrc(appId)) !== null && _$ref1 !== void 0 ? _$ref1 : undefined
        })
    });
    if (disabledLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: logo
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "/",
        children: logo
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 61582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36822);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28821);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_8__);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  -webkit-clip-path: inset(0px 0px 99.9% 99.9%);\n  clip-path: inset(0px 0px 99.9% 99.9%);\n  overflow: hidden;\n  height: 1px;\n  width: 1px;\n  padding: 0;\n  border: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






// @mui




var StyledVisuallyHiddenHeading = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-51b00f93-0"
})(_templateObject());
var Page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var children = _param.children, pageTitle = _param.title, pageDescription = _param.description, _metadataItems = _param.metadataItems, metadataItems = _metadataItems === void 0 ? [] : _metadataItems, openGraphImage = _param.openGraphImage, jsonLd = _param.jsonLd, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "description",
        "metadataItems",
        "openGraphImage",
        "jsonLd"
    ]);
    var _$ref, _$ref1, _$ref2, _$ref3;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var _$ref4 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), rootTitle = _$ref4.title, rootDescription = _$ref4.description, logo = _$ref4.logo, seoMetadataItemsCollection = _$ref4.seoMetadataItemsCollection, companyFavicon = _$ref4.companyFavicon;
    var customTitle = (_$ref = lodash_find__WEBPACK_IMPORTED_MODULE_7___default()(metadataItems, {
        name: "title"
    })) === null || _$ref === void 0 ? void 0 : _$ref.content;
    var customDescription = (_$ref1 = lodash_find__WEBPACK_IMPORTED_MODULE_7___default()(metadataItems, {
        name: "description"
    })) === null || _$ref1 === void 0 ? void 0 : _$ref1.content;
    var title = ((_$ref2 = customTitle || pageTitle) === null || _$ref2 === void 0 ? void 0 : _$ref2.trim()) || rootTitle;
    var description = ((_$ref3 = customDescription || pageDescription) === null || _$ref3 === void 0 ? void 0 : _$ref3.trim()) || rootDescription;
    var openGraphItems = [
        {
            name: "og:type",
            content: "website"
        },
        {
            name: "og:url",
            content:  true ? window.location.href : 0
        },
        {
            name: "og:title",
            content: title
        },
        {
            name: "og:description",
            content: description
        },
        {
            name: "og:locale",
            content: locale
        },
        {
            name: "og:image",
            content: (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.url) || logo
        },
        {
            name: "og:image:alt",
            content: openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.alt
        },
        {
            name: "twitter:title",
            content: title
        },
        {
            name: "twitter:description",
            content: description
        },
        {
            name: "twitter:image:src",
            content: (openGraphImage === null || openGraphImage === void 0 ? void 0 : openGraphImage.url) || logo
        }, 
    ].filter(function(item) {
        return item.content;
    });
    var _$ref5, _content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    lodash_merge__WEBPACK_IMPORTED_MODULE_8___default()(openGraphItems, (_$ref5 = seoMetadataItemsCollection === null || seoMetadataItemsCollection === void 0 ? void 0 : seoMetadataItemsCollection.items) !== null && _$ref5 !== void 0 ? _$ref5 : [], metadataItems).filter(function(item) {
                        return item.name !== "title" && item.name !== "description";
                    }).map(function(metadataItem) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                            name: metadataItem.name,
                            content: (_content = metadataItem.content) !== null && _content !== void 0 ? _content : ""
                        }, metadataItem.name);
                    }),
                    companyFavicon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "apple-touch-icon",
                                sizes: "180x180",
                                href: companyFavicon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "icon",
                                type: "image/png",
                                sizes: "32x32",
                                href: companyFavicon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                                rel: "icon",
                                type: "image/png",
                                sizes: "16x16",
                                href: companyFavicon
                            })
                        ]
                    })
                ]
            }),
            jsonLd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "json-ld-script",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonLd)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                ref: ref
            }, other), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledVisuallyHiddenHeading, {
                        children: title
                    }),
                    children
                ]
            }))
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 95021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ LogoutPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_LoadingScreen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12030);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61582);





var __N_SSG = true;
function LogoutPage(param) {
    var globalSetting = param.globalSetting;
    var ref;
    var companyColor = (ref = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.companyColor) !== null && ref !== void 0 ? ref : undefined;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), query = ref1.query, push = ref1.push;
    var returnTo = query.returnTo;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (returnTo && typeof returnTo === "string") {
            push(returnTo);
        }
    }, [
        returnTo,
        push
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: "logout",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LoadingScreen__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            companyColor: companyColor
        })
    });
}


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6547,9694,1664,9774,2888,179], function() { return __webpack_exec__(67252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);